import React, { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import useTrackPreviews from "../hooks/UseTrackPreviews";
import { useReleases } from "../contexts/MusicContext";

function BackToMusicLink() {
  return (
    <Link to="/music" className="nav-link">
      ← Back to Music
    </Link>
  );
}

function AlbumPage() {
  const { album_name: albumName } = useParams(); // Get the album name from the URL
  const { releases, loading, error } = useReleases();

  // Keep track of the currently playing audio
  const currentAudio = useRef(null);

  const albumReleases = (releases ?? []).filter(
    (release) => release.album_name === albumName,
  );

  const releasesWithPreview = useTrackPreviews(albumReleases);

  if (error) {
    return (
      <div>
        <BackToMusicLink />
        <p>Something went wrong. Could not fetch album.</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div>
        <BackToMusicLink />
        <p>Loading album...</p>
      </div>
    );
  }

  if (!releases || releases.length === 0) {
    return (
      <div>
        <BackToMusicLink />
        <p>No releases found.</p>
      </div>
    );
  }

  const handlePlay = (e) => {
    if (currentAudio.current && currentAudio.current !== e.target) {
      currentAudio.current.pause(); // Pause the previously playing audio
    }
    currentAudio.current = e.target; // Set the current audio
  };

  return (
    <div>
      <BackToMusicLink />
      <div className="album-page">
        <img
          src={releasesWithPreview[0].artwork_url}
          alt={albumName}
          className="album-page-album"
        />
        <div>
          <h1>{albumName}</h1>
          <h2>{releasesWithPreview[0].artist_name}</h2>

          <ul>
            {releasesWithPreview.map((release, index) => (
              <div key={index} className="album-track-with-preview">
                <p className="bold">{release.song_name}</p>
                {release.track_preview === "no_preview_available" ? (
                  <p>Preview not available</p>
                ) : release.track_preview ? (
                  <audio
                    key={release.track_preview} // forces remount when URL changes
                    controls
                    onPlay={handlePlay}
                  >
                    <source src={release.track_preview} type="audio/mpeg" />
                  </audio>
                ) : (
                  <p>Preview loading...</p>
                )}
              </div>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AlbumPage;
